import {Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import ButtonExit from "../button/ButtonExit";
import ButtonAdd from "../button/ButtonAdd";
import React, {useEffect, useState} from "react";
import RulesModifyingOptimizationService from "../../../API/details/customer/RulesModifyingOptimizationService";
import {Box} from "@mui/system";
import RulesModifyingOptimizationTable
    from "../table/optimization/rulesmodifyingoptimization/RulesModifyingOptimizationTable";
import CircularProgress from "@mui/material/CircularProgress";

const ModalRulesModifying = ({modalOpen, handleClose, handleSubmit, handleModalAlert, isLoading}) => {
    const [data, setData] = useState([]);
    const [rowSelection, setRowSelection] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 20,
        totalElements: 0,
        searchData: ""
    })
    useEffect(() => {
        modalOpen && RulesModifyingOptimizationService.getAll().then(function (response) {
            let data = response.data;
            setData(data);
            const dataIds = data.map(el => el.id)
            setRowSelection(dataIds)
            setTableOptions((prev) => ({...prev, totalElements: data.length}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [modalOpen]);

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
    }

    return (
        <Dialog open={modalOpen} PaperProps={{
            style: {
                minWidth: "600px",
                borderRadius: 8,
            }
        }}>
            <DialogTitle textAlign="center">Правила модификации</DialogTitle>
            <DialogContent>
                <Box sx={{padding: "0 30px"}}>
                    <RulesModifyingOptimizationTable
                        data={data}
                        setData={setData}
                        tableOptions={tableOptions}
                        tableOptionsHandle={tableOptionsHandle}
                        handleModalAlert={handleModalAlert}
                        modal={true}
                        rowSelection={rowSelection}
                        setRowSelection={setRowSelection}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                {isLoading && <CircularProgress disableShrink/>}
                <ButtonExit text={"Отменить"} onClick={handleClose}/>
                <ButtonAdd disabled={isLoading} text={"Запустить"} onClick={() => handleSubmit(rowSelection)} />
            </DialogActions>
        </Dialog>
    );
};

export default ModalRulesModifying;